import {
  LABEL_CONTENT_HEIGHT_MM,
  LABEL_CONTENT_WIDTH_MM,
} from "./formats.js";
import type { LabelPrintFormat } from "./types.js";
import type { LabelPrintRotation } from "./rotation.js";
import { computeRollCenterOffsetMm } from "./tspl.js";

const PREVIEW_PAD_MM = 4;

export function resolveLabelPrintLayout(
  format: LabelPrintFormat,
  rotation: LabelPrintRotation = 0,
): {
  pageWidthMm: number;
  pageHeightMm: number;
  contentWidthMm: number;
  contentHeightMm: number;
  contentScale: number;
  sheetTransform: string;
} {
  const innerW = Math.max(10, format.widthMm - PREVIEW_PAD_MM * 2);
  const innerH = Math.max(10, format.heightMm - PREVIEW_PAD_MM * 2);
  const quarter = rotation === 90 || rotation === 270;
  const fitW = quarter ? innerH : innerW;
  const fitH = quarter ? innerW : innerH;
  const contentAspect = LABEL_CONTENT_WIDTH_MM / LABEL_CONTENT_HEIGHT_MM;

  let contentW = fitW;
  let contentH = contentW / contentAspect;
  if (contentH > fitH) {
    contentH = fitH;
    contentW = contentH * contentAspect;
  }

  const sheetTransform =
    rotation === 0 ? "none" : rotation === 180 ? "rotate(180deg)" : `rotate(${rotation}deg)`;

  return {
    pageWidthMm: format.widthMm,
    pageHeightMm: format.heightMm,
    contentWidthMm: contentW,
    contentHeightMm: contentH,
    contentScale: contentW / LABEL_CONTENT_WIDTH_MM,
    sheetTransform,
  };
}

export function labelPrintSizeHint(
  format: LabelPrintFormat,
  rotation: LabelPrintRotation = 0,
): string {
  const rot = rotation === 0 ? "" : ` · contenu ${rotation}°`;
  const center = computeRollCenterOffsetMm(format);
  const rollHint =
    center > 0
      ? ` · rouleau ${format.rollWidthMm} mm (marge gauche ${center} mm)`
      : "";
  return `Format ${format.widthMm}×${format.heightMm} mm${rot}${rollHint} — driver : « ${format.driverName} »`;
}
